import { CatalystColors } from "@certa/catalyst/constants/styles";
import { css } from "emotion";

const container = css({
  display: "flex",
  alignItems: "center",
  flexBasis: "0%",
  maxWidth: "max-content",
  textOverflow: "ellipsis",
  overflow: "hidden",
  flexGrow: 1,
  columnGap: "8px",
  "> div": {
    width: "100%"
  }
});

const triggerButton = css({
  backgroundColor: "inherit",
  border: "none",
  outline: "none",
  padding: "var(--space-4) var(--space-8)",
  borderRadius: "0.25rem",
  cursor: "pointer",
  fontSize: "0.75rem",
  lineHeight: "1rem",
  letterSpacing: "0.015625rem",
  color: CatalystColors.NEUTRAL_700,
  width: "100%",
  display: "flex",
  alignItems: "center",
  columnGap: "8px",
  transition: "background-color 0.2s ease",
  ":hover": {
    backgroundColor: CatalystColors.NEUTRAL_400
  },
  ":focus-visible": {
    outline: "0.125rem solid " + CatalystColors.BRAND_400,
    outlineOffset: "-0.125rem"
  },
  ":focus": {
    outline: "none"
  }
});

/* Prevent icons from shrinking */
const leftIcon = css({
  svg: {
    flexShrink: 0,
    minWidth: "16px",
    minHeight: "16px"
  }
});
/* Prevent chevron from shrinking */
const chevronDown = css({
  flexShrink: 0,
  minWidth: "12px",
  minHeight: "12px"
});

export const BreadcrumbGoToDropdownStyles = {
  container,
  leftIcon,
  triggerButton,
  chevronDown
};
